module.exports = __webpack_public_path__ + "static/img/fruits_mango.8fe7e00.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fruits_mango.png
// module id = sUup
// module chunks = 1